import React, { Component } from 'react';
import { Tooltip } from 'antd';

class CalendarCell extends Component {
    render() {
        const {
            date, dayNum, isRest, planVisitCount, planStartCount,
            hasMemo, isCurrentMonth, isToday, isSelected, onClick,
        } = this.props;

        const cellClass = [
            'calendar-cell',
            !isCurrentMonth && 'other-month',
            isRest === 1 && 'rest-day',
            isToday && 'today',
            isSelected && 'selected',
        ].filter(Boolean).join(' ');

        const hasVisit = planVisitCount > 0;
        const hasStart = planStartCount > 0;

        return (
            <div className={cellClass} onClick={onClick}>
                <div className="cell-header">
                    <span className="day-number">{dayNum}</span>
                    {hasMemo && (
                        <Tooltip title="有备忘录">
                            <img
                                className="memo-icon"
                                src={require('../../../../../public/images/memo.png')}
                                alt=""
                            />
                        </Tooltip>
                    )}
                </div>
                <div className="cell-content">
                    {hasVisit && (
                        <div className="stat-item visit">
                            <span className="stat-label">计划访视数</span>
                            <span className="stat-value">{planVisitCount}</span>
                        </div>
                    )}
                    {hasStart && (
                        <div className="stat-item start">
                            <span className="stat-label">计划启动数</span>
                            <span className="stat-value">{planStartCount}</span>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default CalendarCell;



// WEBPACK FOOTER //
// ./src/components/homePage/monthlyPlan/components/CalendarCell.js